import Urls from "../../api/endpoints";
import Actions from "./actions/actions";
import LinesTables from "./actions/table";
import { Row, Col } from "react-bootstrap";
import LinesHistory from "./actions/history";
import LinesExtended from "./actions/extended";
import Headings from "../../constants/headings";
import Constants from "../../constants/constants";
import { ModalContainer } from "../../shared/index";
import { LineStateStatusType, ModalContentType } from "../../enums/index";
import { NotLogin, Loading, ErrorToast } from "../../shared/index";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Dashboard } from '../../shared/index'

import {
  ErrorHandling,
  ErrorHandlingAPI,
  ToPersianNumber,
} from "../../functions/index";
import { useLocation } from "react-router";
function Lines(props) {
  const [validLines, setValidLines] = useState(null);
  const [extendedLines, setExtendedLines] = useState(null);
  const [historyLines, setHistoryLines] = useState(null);
  const [storedData, setStoredData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [type, setType] = useState(ModalContentType.ActivateLine());
  const [title, setTitle] = useState("");
  const [tempLines, setTempLines] = useState(null);
  const [lineIndex, setLineIndex] = useState(null);
  const [lineId, setLineId] = useState(null);
  const modalValue = useRef("");



  const handleClose = (e = null, submit = null) => {
    if (e) e.preventDefault();
    setShow(false);
    if (submit) {
      if (type === ModalContentType.ActivateLine()) {
        let syncTempLines = tempLines;
        syncTempLines[lineIndex].spinner = true;
        setValidLines(syncTempLines);
        activateLine();
      }
      if (type === ModalContentType.RejectLine()) {
        let syncTempLines = tempLines;
        syncTempLines[lineIndex].spinner = true;
        setValidLines(syncTempLines);
        RejectLine();
      }
    }
  };
  const setPageData = useCallback(() => {

    fetch(Urls.getSearchedUserLinesById(props.userId), {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        let validLinesList = [];
        let historyLinesList = [];
        let extendedLinesList = [];
        data.forEach((element) => {
          if (
            element.Status === LineStateStatusType.Active() ||
            element.Status === LineStateStatusType.Expired() ||
            element.Status === LineStateStatusType.RejectActivation()
          ) {
            element.spinner = false;
            validLinesList.push(element);
          } else if (element.Status === LineStateStatusType.Extended()) {
            extendedLinesList.push(element);
          } else {
            historyLinesList.push(element);
          }
        });
        setValidLines(validLinesList);
        setHistoryLines(historyLinesList);
        setExtendedLines(extendedLinesList);
        setStoredData({
          data: validLinesList,
          history: historyLinesList,
          extended: extendedLinesList,
        });
      })
      .catch((error) => {
        ErrorHandling(error, "lines get error", setLoading);
      });
  }, [props.userId, props.token]);

  useEffect(() => {
    setPageData();
  }, [setPageData]);
  const activateLineModal = (e, id) => {
    e.preventDefault();
    setType(ModalContentType.ActivateLine());
    setTitle("");
    for (let index = 0; index < validLines.length; index++) {
      if (validLines[index].Id === id) {
        modalValue.current = ToPersianNumber(validLines[index].LineNumber);
        setLineIndex(index);
      }
    }
    setShow(true);
    setTempLines(validLines);
    setLineId(id);
  };
  const activateLine = () => {
    fetch(Urls.activateLines(lineId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
      body: JSON.stringify(""),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.Success) {
          setPageData();
        } else {
          ErrorHandlingAPI(data);
          setPageData();
        }
      })
      .catch((error) => {
        setPageData();
        ErrorHandling(error, "line validate error");
      });
  };
  const rejectLineModal = (e, id) => {
    e.preventDefault();
    setType(ModalContentType.RejectLine());
    setTitle(Headings.RejectActivationReasonModalTitle);
    for (let index = 0; index < validLines.length; index++) {
      if (validLines[index].Id === id) {
        modalValue.current = ToPersianNumber(validLines[index].LineNumber);
        setLineIndex(index);
      }
    }
    setShow(true);
    setTempLines(validLines);
    setLineId(id);
  };
  const RejectLine = () => {
    fetch(Urls.rejectActivationLines(lineId, modalValue.current), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

        Authorization: "Bearer " + props.token,
      },
      body: JSON.stringify(""),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.Success) {
          setPageData();
          ErrorToast(Constants.RejectActivationToastText);
        } else {
          ErrorHandlingAPI(data);
          setPageData();
        }
      })
      .catch((error) => {
        setPageData();
        ErrorHandling(error, "line reject activation error");
      });
  };
  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : loading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-service-container">
            <div className="user-info">
              <h1>{Headings.LinesHeading}</h1>
              <div className="divider"></div>
              <Actions
                data={validLines}
                history={historyLines}
                extended={extendedLines}
                setHistory={setHistoryLines}
                setData={setValidLines}
                setExtendedLines={setExtendedLines}
                storedData={storedData}
              ></Actions>

              <Row>
                <Col className="mt-5">
                  <h2>{Headings.ActiveLinesTitle}</h2>
                  <LinesTables
                    heading={Headings.LinesTableHeading}
                    data={validLines}
                    activateLineModal={activateLineModal}
                    rejectLineModal={rejectLineModal}
                  ></LinesTables>
                </Col>
              </Row>
              {extendedLines && extendedLines.length > 0 && (
                <Row>
                  <Col className="mt-5">
                    <h2>{Headings.ExtendeLines}</h2>
                    <LinesExtended
                      heading={Headings.LinesTableExtendedHeading}
                      data={extendedLines}
                    ></LinesExtended>
                  </Col>
                </Row>
              )}

              <Row>
                <Col className="mt-5">
                  <h2>{Headings.LinesHistoryTitle}</h2>
                  <LinesHistory
                    heading={Headings.LinesTableHistoryHeading}
                    data={historyLines}
                  ></LinesHistory>
                </Col>
              </Row>
            </div>
          </div>
          <ModalContainer
            show={show}
            type={type}
            title={title}
            handleClose={handleClose}
            data={modalValue}
          ></ModalContainer>
        </>
      )}
    </main>
  );
}
export default Lines;
